module.exports = __webpack_public_path__ + "media/images/user-1-740ea735d41e346ea492363cfff84193.jpg";